import * as React from 'react'
import AdminExternalCategoriesMappings from './AdminExternalCategoriesMappings'
import AdminExternalCitiesMappings from './AdminExternalCitiesMappings'
import { SelectFormField, SelectOptionModel } from 'traveldesk-ui'
import ExternalIntegrationsApiService from '../../services/ExternalIntegrationsApiService'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
interface Props {

}
enum ExternalMappingPageType {
    Categories, Cities
}
const AdminExternalMappings = (props: Props) => {
    const dispatch = useDispatch()
    const [apiIntegrationsOptions, setApiIntegrationsOptions] = React.useState<SelectOptionModel[]>([])
    const [mappingType, setExternalMappingType] = React.useState<ExternalMappingPageType>(ExternalMappingPageType.Categories)
    const [apiIntegrationId, setApiIntegrationId] = React.useState<number | undefined>(undefined)
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    React.useEffect(() => {
        getApiIntegrations()
    }, [])
    const getApiIntegrations = async () => {
        const apiIntegrationsResponse = await ExternalIntegrationsApiService.getApiIntegrations(dispatch)
        if (apiIntegrationsResponse.IsOk && apiIntegrationsResponse.Content) {
            setApiIntegrationsOptions(apiIntegrationsResponse.Content)
        }
    }

    return <div className="tab-content-block is-active" data-tab="tab-v01">
        <SelectFormField placeholder='Select API Integration' options={apiIntegrationsOptions} value={apiIntegrationId} onChange={(e: SelectOptionModel) => setApiIntegrationId(e.value as number)} />
        <div className="tabs-wrapper is-horizontal">
            <div className="tab-head">
                <div className={`tab-head-item clickable ${mappingType == ExternalMappingPageType.Categories ? "is-active" : ""}`} onClick={() => setExternalMappingType(ExternalMappingPageType.Categories)}>
                    {Localization.getString('Categories')}
                </div>
                <div className={`tab-head-item clickable ${mappingType == ExternalMappingPageType.Cities ? "is-active" : ""}`} onClick={() => setExternalMappingType(ExternalMappingPageType.Cities)}>
                    {Localization.getString('Cities')}
                </div>
            </div>
        </div>
        {mappingType == ExternalMappingPageType.Categories
            ? <AdminExternalCategoriesMappings apiProviderId={apiIntegrationId} />
            : <AdminExternalCitiesMappings apiProviderId={apiIntegrationId} />}
    </div>
}
export default AdminExternalMappings